import React from 'react';
import { useNavigate } from 'react-router-dom';
import './WhatWeBelieve.css'; // Import CSS for styling

const WhatWeBelieve = () => {
  const navigate = useNavigate();

  return (
    <div className="what-we-believe-container">
      <h1 className="what-we-believe-title">What We Believe</h1>

      <section className="belief-section">
        <h2>Faith-Based Science-Backed</h2>
        <p>
          At Abstinent Adolescents, we believe that abstinence is the best choice for adolescents and young adults. Our beliefs are grounded in both scientific research and our Christian faith. We are committed to providing accurate information about the benefits of abstinence while also upholding our faith-based values.
        </p>
      </section>

      <section className="belief-section">
        <h2>We are a Christian organization</h2>
        <p>
          Abstinent Adolescents is a Christian organization. However, we are open to membership for everyone regardless of their religious identity. We are against judging others for their past sexual choices and want to help wer people to move forward to make better choices. We seek to embody the love of Jesus in our efforts by showing grace to others, and we acknowledge that none of us are perfect. We believe that the Bible is the Word of God and that we would all benefit from following the principles laid out in the Scriptures.
        </p>
      </section>

      <section className="belief-section">
        <h2>Purity to Glorify God</h2>
        <p>
          We believe our sole purpose is to glorify God in everything we do. God has created us in His image and has called each of us to walk in holiness. We can pursue holiness by seeking purity of the mind, heart, and body. We are committed to providing a community and resources that will promote each individual's journey in sexual purity. (1 Corinthians 6:18-20, Psalm 119:9, 1 Thessalonians 4:3-8)
        </p>
      </section>

      <section className="belief-section">
        <h2>The Sanctity of Marriage</h2>
        <p>
          We believe that sex is good and was created by God to be enjoyed within the context of marriage. God established marriage to be a covenant between one man and one woman under God. This union is consummated in sexual intercourse. God affirms the beauty of marriage and sex within marriage. We are committed to helping others implement practical steps in their abstinence journey. (Genesis 1:28, 2:18-24, Mark 10:1-9, Ephesians 5:22-33, 1 Corinthians 7:3-5, Hebrews 13:4)
        </p>
      </section>

      <section className="belief-section">
        <h2>Sexual Immorality Defined</h2>
        <p>
          We believe that due to mankind's disobedience, we have all fallen short of God's standard of sexual purity and instead chose to pursue sexual immorality. Sexual immorality encompasses any behavior that falls outside of God's intended means for us to express sexual intimacy. Some of these behaviors include sex before marriage, masturbation, and consuming pornography. (1 Corinthians 7:1-2, Romans 1:24-32, 1 Corinthians 6:18, Ephesians 5:3, 2 Timothy 2:22)
        </p>
      </section>

      <section className="belief-section">
        <h2>Holistic Health</h2>
        <p>
          We believe that abstinence is the best choice for our physical, mental, and spiritual health.
        </p>
        <ul>
          <li><strong>Physical Health</strong> - Complete abstinence is the only way to guarantee protection against STDs and pregnancy. Those who choose not to wait until marriage put themselves at risk of STDs and unplanned pregnancies.</li>
          <li><strong>Mental Health</strong> - We believe that abstinence is important for protecting our mental health, especially for young people. There is strong evidence that adolescent sex can play a causal role in the development of depressive disorders. Many people struggle with anxiety and insecurity as a result of premarital sex. We believe that many of the mental health struggles that people face would be bettered by abstaining.</li>
          <li><strong>Spiritual Health</strong> - We believe that abstinence is important for protecting our spiritual health. God has called each of us to avoid sin and pursue Him. We abstain to glorify God in our bodies and grow closer in relationship with Him.</li>
        </ul>
      </section>

      <button onClick={() => navigate('/our-story')} className="belief-button">
        Read Our Story
      </button>
    </div>
  );
};

export default WhatWeBelieve;
